<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">氢能</span> > 价格</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>价格</p>
        <div class="btn fr" @click="search">搜索</div>
        <input v-if="this.queryParams['dictDataType'] !== '101' && this.queryParams['dictDataType'] !== '102'" class="fr" type="text" v-model="queryParams.likeTitleName" placeholder="请输入关键词">
        <input v-else class="fr" type="text" v-model="query.likeTitleName" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('issue_hydrogen_company_price')" :class="{'hover':queryParams['dictDataType'] === 'issue_hydrogen_company_price'}">氢气企业
        </div>
        <div @click="changeTabs('issue_hydrogen_area_price')" :class="{'hover':queryParams['dictDataType'] === 'issue_hydrogen_area_price'}">氢气地区
        </div>
        <div @click="changeTabs('manual_hydrogen_heavy_company_price')" :class="{'hover':queryParams['dictDataType'] === 'manual_hydrogen_heavy_company_price'}">重点氢气企业
        </div>
        <div @click="changeTabs('101')" :class="{'hover':queryParams['dictDataType'] === '101'}">商品氢</div>
        <div @click="changeTabs('102')" :class="{'hover':queryParams['dictDataType'] === '102'}">电堆</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <p v-if="queryParams['dictDataType'] === 'issue_hydrogen_company_price' || queryParams['dictDataType'] === 'issue_hydrogen_area_price'|| queryParams['dictDataType'] === 'manual_hydrogen_heavy_company_price'"
             @click="goDetail(item.completeOriginalDate, queryParams['dictDataType'])">{{
              item.date + (queryParams['dictDataType'] === 'issue_hydrogen_company_price' ? '氢气企业价格' : queryParams['dictDataType'] === 'issue_hydrogen_area_price' ? '氢气地区价格' :'重点氢气企业价格')
            }}</p>
          <p v-else @click="goDetail(item.id, queryParams['dictDataType'])">{{ item.titleName }}</p>
          <span
              v-if="queryParams['dictDataType'] === 'issue_hydrogen_company_price' || queryParams['dictDataType'] === 'issue_hydrogen_area_price'|| queryParams['dictDataType'] === 'manual_hydrogen_heavy_company_price'"
              class="fr">{{ item.completeOriginalDate }}</span>
          <span v-else class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams['pageSize']"
          :current-page="queryParams['pageNum']"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  priceList,
  priceListXin
} from '@/api/hydrogen'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        dictDataType: 'issue_hydrogen_company_price',
        likeTitleName:'',
        dataType: 2,
      },
      query: {
        pageNum: 1,
        pageSize: 15,
        sourceType: '101'
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.query['flag']) {
      this.queryParams['dictDataType'] = this.$route.query['flag']
      this.query['sourceType'] = this.$route.query['flag']
    }
    if (this.$route.query['num']) {
      this.queryParams['dataType'] = this.$route.query['num']
    }
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      this.list = []
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.queryParams['dictDataType'] === '101' || this.queryParams['dictDataType'] === '102') {
        priceListXin(this.query).then(res => {
          this.list = res.rows;
          this.total = res.total;
          loading.close();
        })
      } else {
        priceList(this.queryParams).then(res => {
          this.list = res.rows;
          this.total = res.total;
          loading.close();
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      this.query['pageNum'] = 1;
      this.queryParams['pageNum'] = 1;
      this.getList()
    },
    /**
     * 切换tabs
     */
    changeTabs(flag) {
      this.queryParams['dictDataType'] = flag;
      this.query['sourceType'] = flag;
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList();
    },
    /**
     * 前往详情页
     */
    goDetail(id, flag) {
      if (this.queryParams['dictDataType'] === '101' || this.queryParams['dictDataType'] === '102') {
        this.$router.push({path: `/hydrogen/priceXin`, query: {id, flag}})
      } else {
        this.$router.push({path: `/hydrogen/price`, query: {id, flag}})
      }
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/hydrogen')
    },
    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.query['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
